/* @flow */

import React from 'react';
import { pure } from 'recompose';
import { css } from 'glamor';

import { ZINDEX_OVERLAY_BG, ZINDEX_MODAL } from 'depop/styles/zIndex';

import FixedPage from 'react-fixed-page';

const KEYCODES = {
  ESCAPE: 27,
};

class ModalShell extends React.Component {
  props: {
    children: React.Element,
    closePortal: () => void,
    next: ?() => void,
    previous: ?() => void,
  };

  state: {
    isOpen: boolean,
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  handleKeyDown = event => {
    if (event.keyCode === KEYCODES.ESCAPE) {
      this.close();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    setTimeout(() => {
      this.setState({ isOpen: true });
    }, 4);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  close = (): void => {
    const { closePortal } = this.props;
    this.setState({ isOpen: false });
    setTimeout(() => {
      closePortal();
    }, 200);
  };

  handleCloseClick = event => {
    event.preventDefault();
    this.close();
  };

  render() {
    const { children } = this.props;
    const { isOpen } = this.state;

    const rootStyles = css({
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',
      cursor: 'default',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 0 100px 0 rgba(0, 0, 0, .25)',
      transition: `
        transform .1s ease-in-out,
        opacity .1s ease-in-out,
        margin .05s ease-in-out,
        max-width .1s ease-in-out,
        min-height .1s ease-in-out`,
      opacity: isOpen ? 1 : 0,
      transform: isOpen ? 'scale(1)' : 'scale(0)',
      pointerEvents: 'all',
      '@media (min-width: 701px)': {
        width: 'auto',
        maxWidth: 'calc(100% - 32px)',
        height: 'auto',
      },
    });

    return (
      <div
        {...css({
          position: 'fixed',
          zIndex: ZINDEX_OVERLAY_BG,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        })}>
        <div
          onClick={this.close}
          {...css({
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: `rgba(0, 0, 0, 0.4)`,
            opacity: isOpen ? 1 : 0,
            transition: 'opacity .1s ease-in-out',
          })}
        />
        <div
          {...css({
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: ZINDEX_MODAL,
            pointerEvents: 'none',
          })}>
          <FixedPage fixed={isOpen} />
          <div {...rootStyles}>
            <div
              {...css({
                width: '100%',
                height: '100%',
                backgroundColor: '#FFFFFF',
              })}>
              {React.cloneElement(children, {
                closeModal: this.close,
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default pure(ModalShell);



// WEBPACK FOOTER //
// ../src/client/components/modal/ModalShell.js